import { createApp } from 'vue'
import PageEditor from './PageEditor.vue'
import '@/lib/hydrateStripes/index'

const app = createApp(PageEditor)

let el = document.getElementById('vssl-page-editor')
if (!el) {
  el = document.createElement('div')
  el.id = 'vssl-page-editor'
  document.body.appendChild(el)
}

app.mount(el)
